import { isRouteErrorResponse, Outlet, useLocation, useRouteError } from "react-router-dom";
import { Content } from "antd/es/layout/layout";
import DefaultErrorFallback from "components/DefaultErrorFallback";
import MainLayout from "layout/MainLayout";
import ProtectedRoutes from "shared/routes/ProtectedRoutes";
import { ConfigProvider } from "antd";
import { theme } from "shared/theme";
import { useAuth } from "context/AuthContextProvider";
import SystemAdminLayout from "layout/SystemAdminLayout";
import { isSystemAdmin as checkIsSystemAdmin } from "shared/utils/role";

function App() {
  // Handle errors, navigating to DefaultErrorFallback page
  let error = useRouteError();
  const { state } = useAuth();
  const isSystemAdmin = checkIsSystemAdmin(state.user?.roles);
  // A new path is a new page. Without the key, two paths of the SAME route
  // (one package then another, /customer/package/:id) or two routes with the
  // same page component (the Karyawan lists) reuse one mounted page, so a
  // modal opened on the second stayed open over the first after Back. A
  // search-param change (tabs, filters, ?occurrence_timestamp=) keeps the
  // page mounted, as before.
  const { pathname } = useLocation();

  return (
    <ProtectedRoutes>
      {/* Locale comes from LanguageRoot at the app root (index.js); AntD 5
          ConfigProviders merge with ancestors, so this one only adds theme. */}
      <ConfigProvider theme={theme}>
        {isSystemAdmin ? (
          <SystemAdminLayout>
            <Content>
              {/* Renders fallback if its not 404 Error */}
              {!isRouteErrorResponse(error) ? <Outlet key={pathname} /> : <DefaultErrorFallback />}
            </Content>
          </SystemAdminLayout>
        ) : (
          <MainLayout>
            <Content>
              {/* Renders fallback if its not 404 Error */}
              {!isRouteErrorResponse(error) ? <Outlet key={pathname} /> : <DefaultErrorFallback />}
            </Content>
          </MainLayout>
        )}
      </ConfigProvider>
    </ProtectedRoutes>
  );
}

export default App;
